export const ADMIN_WHITELIST = [
  // Add trusted admin emails here (case-insensitive check)
  "beqaa.shvelidze@gmail.com",
  // Removed generic admin@example.com for security
];

export function isWhitelistedAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  
  // Security: Prevent placeholder/example emails
  if (email.includes("example.com") || email.includes("test.com") || email.includes("placeholder")) {
    return false;
  }
  
  const lower = email.toLowerCase().trim();
  return ADMIN_WHITELIST.some((e) => e.toLowerCase() === lower);
}
